import { Box } from '@factorialco/deprecated-design-system'
import { F0Icon, F0Text } from '@factorialco/f0-react'
import { Sleep } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'
import type { RestDayGridEvent } from 'modules/shift_management/utils/TimeGridTable/transformEvents'

import type { EventCardSpec } from 'modules/shift_management/utils/TimeGridTable/resolveCard'

const RestDayCard: EventCardSpec<RestDayGridEvent> = {
  getAppearance: (event) => ({
    background: event.isDraft ? 'grey100' : 'grey200',
    opacity: '1',
    border: undefined,
  }),
  render: () => (
    <Box flexDirection="row" alignItems="center" gap="s4" padding="s4" paddingBottom="s20">
      <F0Icon icon={Sleep} size="sm" color="secondary" />
      <F0Text variant="label" content={i18n.t('shift_management.cells.rest_day.title')} ellipsis />
    </Box>
  ),
}

export { RestDayCard }
